/* eslint-disable @typescript-eslint/space-before-function-paren */
import differenceInCalendarMonths from 'date-fns/differenceInCalendarDays';
import { isFalsy } from '../../../utils/common';
var CFCourseUtil = /** @class */ (function () {
    function CFCourseUtil(course) {
        this.course = null;
        this.getDateDiff = function (date) {
            var updatedDate = new Date(date);
            var today = new Date();
            var daysDiff = differenceInCalendarMonths(today, updatedDate);
            // return daysDiff < 30 * 6 ? `${daysDiff} days ago` : 'more than 6 months ago';
            return daysDiff;
        };
        this.convertInputToReadableCurrencyFormat = function (fee, currencyCode) {
            if (['PKR', 'INR'].includes(currencyCode !== null && currencyCode !== void 0 ? currencyCode : '')) {
                return "".concat(currencyCode, " ").concat(fee === null || fee === void 0 ? void 0 : fee.toLocaleString('en-IN'));
            }
            return "".concat(currencyCode, " ").concat(fee === null || fee === void 0 ? void 0 : fee.toLocaleString('en-US'));
        };
        this.course = course;
    }
    CFCourseUtil.prototype.getApplicationFeeLabel = function () {
        var _a, _b, _c, _d, _e;
        if (isFalsy((_a = this.course) === null || _a === void 0 ? void 0 : _a.tuitionFeeCurrencyCode) || isFalsy((_b = this.course) === null || _b === void 0 ? void 0 : _b.applicationFee))
            return '-';
        return ((_e = this.convertInputToReadableCurrencyFormat((_c = this.course) === null || _c === void 0 ? void 0 : _c.applicationFee, (_d = this.course) === null || _d === void 0 ? void 0 : _d.tuitionFeeCurrencyCode)) !== null && _e !== void 0 ? _e : '-');
    };
    CFCourseUtil.prototype.getTutionFeeLabel = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!((_a = this.course) === null || _a === void 0 ? void 0 : _a.tuitionFeeCurrencyCode))
            return '-';
        if (this.course.tuitionFeePerYear) {
            return ((_d = this.convertInputToReadableCurrencyFormat((_b = this.course) === null || _b === void 0 ? void 0 : _b.tuitionFeePerYear, (_c = this.course) === null || _c === void 0 ? void 0 : _c.tuitionFeeCurrencyCode)) !== null && _d !== void 0 ? _d : '-');
        }
        else if (this.course.tuitionFeeOverall) {
            return ((_g = this.convertInputToReadableCurrencyFormat((_e = this.course) === null || _e === void 0 ? void 0 : _e.tuitionFeeOverall, (_f = this.course) === null || _f === void 0 ? void 0 : _f.tuitionFeeCurrencyCode)) !== null && _g !== void 0 ? _g : '-');
        }
        else {
            return '-';
        }
    };
    CFCourseUtil.prototype.getTutionFeeTitle = function () {
        var _a;
        return ((_a = this.course) === null || _a === void 0 ? void 0 : _a.tuitionFeePerYear) ? 'Tuition Fee Per Year' : 'Tuition Fee';
    };
    CFCourseUtil.prototype.getDurationLabel = function () {
        var _a;
        if (!((_a = this.course) === null || _a === void 0 ? void 0 : _a.duration))
            return '-';
        return "".concat(this.course.duration, " Months");
    };
    CFCourseUtil.prototype.getTutionFeeToolTipLabel = function () {
        var _a, _b, _c;
        if (!((_a = this.course) === null || _a === void 0 ? void 0 : _a.tuitionFeeCurrencyCode))
            return undefined;
        if (this.course.tuitionFeePerYear && this.course.tuitionFeePerYearInr) {
            return "INR ".concat((_b = this.course.tuitionFeePerYearInr) === null || _b === void 0 ? void 0 : _b.toLocaleString('en-IN'));
        }
        else if (this.course.tuitionFeeOverall && this.course.tuitionFeeOverallInr) {
            return "INR ".concat((_c = this.course.tuitionFeeOverallInr) === null || _c === void 0 ? void 0 : _c.toLocaleString('en-IN'));
        }
        else {
            return undefined;
        }
    };
    CFCourseUtil.prototype.getShowVerifiedFlag = function () {
        var _a, _b, _c;
        if (((_a = this.course) === null || _a === void 0 ? void 0 : _a.eligibilityDataVerified) === true) {
            return true;
        }
        else {
            // creation date less than 6 months ago
            return this.getDateDiff((_c = (_b = this.course) === null || _b === void 0 ? void 0 : _b.createdAt) !== null && _c !== void 0 ? _c : '') < 30 * 6;
        }
    };
    return CFCourseUtil;
}());
export default CFCourseUtil;
//# sourceMappingURL=CFCourseUtil.js.map